import { getArticleSchemaDatePublished } from '../utils/dates';

export const getArticleSchema = (data) => {
  const post = data?.post?.edges?.[0]?.node;
  if (!post) return null;

  const articleSchema = {
    '@context': 'https://schema.org',
    '@type': 'BlogPosting',
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': `https://cloudkitchens.com/${post.slug.replace(/^\/+/, '')}`,
    },
    headline: post.meta.title,
    description: post.meta.description,
    image: post?.feature_image?.url,
    author: {
      '@type': 'Person',
      name: post.author.name,
    },
    publisher: {
      '@type': 'Organization',
      name: 'CloudKitchens',
      logo: {
        '@type': 'ImageObject',
        url: 'https://images.prismic.io/cloudkitchens-main/ff133817-2037-40b0-ab16-58f6b0ba2f13_LogoB.png?auto=compress,format',
      },
    },
    datePublished: getArticleSchemaDatePublished(post?.published),
  };

  if (!articleSchema) {
    return null;
  } else {
    return JSON.stringify(articleSchema, null, 2);
  }
};
